// Generated by ts-to-zod
import { z } from 'zod';
import { queueRuleSchema } from '../../../rules/models/queueRule.schema';
import { urlSchema } from '../../../utils/codecUtils.schema';

export const suggestTriggerConditionPayloadSchema = z.object({
  userQuery: z.string(),
  schemaRule: queueRuleSchema.partial(),
  queue: urlSchema,
});

export const suggestTriggerConditionResultSchema = z.object({
  triggerCondition: z.string().optional(),
  triggerConditionSummary: z.string().optional(),
});

export const suggestTriggerConditionResponseSchema = z.object({
  results: z.array(suggestTriggerConditionResultSchema),
});
